/**
 * Amène le regard et le curseur sur le premier champ en erreur d'une section.
 *
 * Les champs en erreur portent `data-invalid="<clé de section>"` : la clé évite
 * qu'une section refusée plus haut dans la page (tunnel v1, où tout s'empile)
 * capte le focus à la place de celle qu'on vient de tenter de confirmer.
 *
 * @param {HTMLElement|null} root - Zone où chercher.
 * @param {string} sectionKey - Section dont la confirmation vient d'être refusée.
 * @returns {boolean} vrai si un champ a été trouvé.
 */
export function focusFirstInvalid(root, sectionKey) {
  const target = root?.querySelector(`[data-invalid="${sectionKey}"]`)
  if (!target) return false
  // Le MESSAGE au centre, plutôt que le champ : un champ haut (la liste des
  // types d'établissement) centré entier laissait son message sous le pied
  // collant de la fenêtre — le rouge se voyait, pas ce qu'il demandait.
  const repere = target.querySelector('[role="alert"]') || target
  repere.scrollIntoView?.({ block: 'center', behavior: 'smooth' })
  const control = target.querySelector(
    'input:not([disabled]), textarea:not([disabled]), select:not([disabled])'
  )
  control?.focus({ preventScroll: true })
  return true
}
